import React from 'react';
import { Mail, Phone, Linkedin } from 'lucide-react';
export const ContactSection = () => {
  return <section id="contact" className="w-full py-24 bg-gray-50 relative" data-id="element-14">
      {/* Subtle image in the background */}
      <div className="absolute inset-0 z-0 opacity-5" data-id="element-15">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mgkTKELmddAtkSK2GwbSzo/Gemini_Generated_Image_atlna1atlna1atln.png" alt="" className="w-full h-full object-cover" data-id="element-16" />
      </div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-17">
        <div className="max-w-3xl" data-id="element-18">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-10" data-id="element-19">
            Let's work together
          </h2>
          <p className="text-xl text-gray-600 mb-12 leading-relaxed" data-id="element-20">
            I help product teams find clarity, alignment, and direction. If
            you're looking to improve your product strategy or team
            collaboration, let's talk.
          </p>
          <div className="flex flex-col gap-8 mb-12" data-id="element-21">
            <a href="mailto:grittyDV@gmail.com" className="flex items-center gap-4 text-gray-900 hover:text-blue-700 transition-colors group" data-id="element-22">
              <Mail size={24} className="group-hover:scale-110 transition-transform" data-id="element-23" />
              <span className="text-lg" data-id="element-24">grittydv@gmail.com</span>
            </a>
            <a href="tel:+4520750177" className="flex items-center gap-4 text-gray-900 hover:text-blue-700 transition-colors group" data-id="element-25">
              <Phone size={24} className="group-hover:scale-110 transition-transform" data-id="element-26" />
              <span className="text-lg" data-id="element-27">+45 20 75 01 77</span>
            </a>
            <a href="https://www.linkedin.com/in/sandormoricz/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 text-gray-900 hover:text-blue-700 transition-colors group" data-id="element-28">
              <Linkedin size={24} className="group-hover:scale-110 transition-transform" data-id="element-29" />
              <span className="text-lg" data-id="element-30">Connect on LinkedIn</span>
            </a>
          </div>
          
        </div>
      </div>
    </section>;
};